import React from 'react';
import { useState } from "react";
import {
    DataGrid,
} from "@mui/x-data-grid";
import {
    Box,
    Button,
    Modal,
} from "@mui/material";
import MessageDisplay from './MessageDisplay';
import CustomerStatusChange from './CustomerStatusChange';
import Reply2Customer from './Reply2Customer';
import { useDeleteMessage } from '../../hooks/useMessages';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
  };

function CustomerDataGrid({messages, i}){
    /// datagrid that displays all customers who have messaged processor
    const deleteMessageMutation = useDeleteMessage();
    const [rowItem, setRowItem] = useState();
    const [editRowsModel, setEditRowsModel] = React.useState({});
    const [open, setOpen] = React.useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    const [open1, setOpen1] = React.useState(false);
    const handleOpen1 = () => setOpen1(true);
    const handleClose1 = () => setOpen1(false);
    const [open2, setOpen2] = React.useState(false);
    const handleOpen2 = () => setOpen2(true);
    const handleClose2 = () => setOpen2(false);

    function showMessage(cellValues) { // hadles the double click to bring up modal to edit crop amount
        setRowItem({
            id: cellValues.row.id,
            companyId: cellValues.row.companyId,
            created: cellValues.row.created,
            deleted: cellValues.row.deleted,
            message: cellValues.row.message,
            requestStatus: cellValues.row.requestStatus,
            userId: cellValues.row.userId,
            userEmail: cellValues.row.userEmail,
            userName: cellValues.row.customerName,
            reply: cellValues.row.reply
        })
        handleOpen();
    };
    function editStatus(cellValues) { // hadles the double click to bring up modal to edit crop amount
        setRowItem({
            id: cellValues.row.id,
            companyId: cellValues.row.companyId,
            created: cellValues.row.created,
            deleted: cellValues.row.deleted,
            message: cellValues.row.message,
            requestStatus: cellValues.row.requestStatus,
            userId: cellValues.row.userId,
            userEmail: cellValues.row.userEmail,
            userName: cellValues.row.customerName,
            reply: cellValues.row.reply
        })
        handleOpen1();
    };

    function replyMessage(cellValues){
        setRowItem({
            id: cellValues.row.id,
            companyId: cellValues.row.companyId,
            created: cellValues.row.created,
            deleted: cellValues.row.deleted,
            message: cellValues.row.message,
            requestStatus: cellValues.row.requestStatus,
            userId: cellValues.row.userId,
            userEmail: cellValues.row.userEmail,
            userName: cellValues.row.customerName,
            reply: cellValues.row.reply
        })
        handleOpen2();
    };

    function deleteMessage(cellValues){
        setRowItem({
            id: cellValues.row.id,
        })
        deleteMessageMutation.mutate({id:cellValues.row.id, companyId: cellValues.row.companyId})
    };

    const columns = [
        { field: 'companyContact', headerName: 'Company', width: 175, headerClassName: 'header', editable: false,},
        { field: 'companyEmail', headerName: 'Email', width: 300, headerClassName: 'header', editable: false,},
        { field: 'requestStatus', headerName: 'Status', width: 300, headerClassName: 'header', editable: false,
            renderCell: (cellValues) => {
                if (cellValues.row.requestStatus === 0){
                    return(
                        <div>
                            <Button variant="contained" color="secondary" onClick={() => editStatus(cellValues)}>Pending</Button>
                        </div>
                    )
                } else if(cellValues.row.requestStatus === 1){
                    return(
                        <div>
                            <Button variant="contained" color="success" onClick={() => editStatus(cellValues)}>Approved with Invoice</Button>
                        </div>
                    )
                } else if(cellValues.row.requestStatus === 2){
                    return(
                        <div>
                            <Button variant="contained" color="warning" onClick={() => editStatus(cellValues)}>Approved with Card</Button>
                        </div>
                    )
                } else if(cellValues.row.requestStatus === 3){
                    return(
                        <div>
                            <Button variant="contained" color="error" onClick={() => editStatus(cellValues)}>Denied</Button>
                        </div>
                    )
                }
            }
        },
        { field: 'messageTab', headerName: 'Message', width: 200, headerClassName: 'header', sortable: false,
            renderCell: (cellValues) => {
                if(cellValues.row.rulerNotes){
                    return(<Button onClick={() => showMessage(cellValues)} style={{justifyContent:'flex-start', overflow: 'hidden', textOverflow: 'ellipsis', }}>{cellValues.row.message}</Button>)
                } else {
                    return(<Button onClick={() => showMessage(cellValues)} style={{justifyContent:'flex-start', overflow: 'hidden', textOverflow: 'ellipsis'}}>No Notes</Button>)
                }
            }
        },
        { field: 'replyTab', headerName: 'Reply', width: 150, headerClassName: 'header', sortable: false,
            renderCell: (cellValues)=> {
                if(cellValues.row.reply ){
                    return(
                    <div>
                        <Button variant="contained" color="success" onClick={() => replyMessage(cellValues)}>Reply</Button>
                    </div>
                )} else {
                    return(
                        <div>
                            <Button variant="contained" color="secondary" onClick={() => replyMessage(cellValues)}>Reply</Button>
                        </div>
                    )}
            }
        },
        { field: 'Remove', width:125, headerClassName: 'header', sortable: false,
            renderCell: (cellValues)=> {
                if(cellValues.row.requestStatus === 3){
                    return(
                <div>
                    <Button variant="contained" color="error" onClick={() => deleteMessage(cellValues)}>Delete</Button>
                </div>
                    )
                }
            }
        },
    ];

    return(
        <Box sx={{ '& .header': { backgroundColor: '#e2e2e2' }, height: '80vh' }}>
            <DataGrid
                key={i}
                editMode="row"
                editRowsModel={editRowsModel}
                columns={columns}
                rows={messages}
                style={{textAlign:'left'}}
            />
            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <MessageDisplay item={rowItem} />
                </Box>
            </Modal>
            <Modal
                open={open1}
                onClose={handleClose1}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <CustomerStatusChange item={rowItem} handleClose1={handleClose1} handleClose2={handleClose2}/>
                </Box>
            </Modal>
            <Modal
                open={open2}
                onClose={handleClose2}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <Reply2Customer item={rowItem} handleClose1={handleClose1} handleClose2={handleClose2}/>
                </Box>
            </Modal>
        </Box>
    )
};

export default CustomerDataGrid;